import type { ProLayoutProps } from '@ant-design/pro-layout';

/**
 * Get all paths from the route config object(config for ProLayout sidenav)
 */
export const getAllRoutePaths = (layoutRoutes: ProLayoutProps['route']) => {
  const traverse = (routes: ProLayoutProps['route']): string[] => {
    return (routes?.children ?? []).flatMap(route => [route.path as string, ...traverse(route)]);
  };

  return traverse(layoutRoutes);
};
